<template>
  <div class="global-typography">
    <v-container class="faq-sections" d-flex pa-0>
      <v-row>
        <v-col xs12 class="faq-section" v-for="item in faqSections" :key="item.id">
          <a class="section-link" :href="item.SectionTitleId">
            {{ item.SectionTitle }}
          </a>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { Text, RichText, isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'FaqSections',
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  computed: {
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
    faqSections() {
      let list = [];
      let id = 1;
      if (this.fields.FaqSections) {
        this.fields.FaqSections.forEach((item) => {
          let sectionTitleVar;
          if (item && item.fields && item.fields.SectionTitle && item.fields.SectionTitle.value) {
            sectionTitleVar = item.fields.SectionTitle.value;
          }

          if (sectionTitleVar) {
            list.push({
              id: id,
              SectionTitle: sectionTitleVar,
              SectionTitleId: '#' + sectionTitleVar.replace(/ /g, '-'),
            });
            id++;
          }
        });
      }
      return list;
    },
  },
  methods: {},
  components: {
    ScText: Text,
    ScRichText: RichText,
  },
};
</script>
<style lang="scss" scoped>
.faq-sections {
  margin-top: 10px;
  margin-bottom: 10px;

  &::v-deep {
    .faq-section {
      min-width: 200px;
      a {
        text-decoration: none !important;
        color: map-deep-get($colors, 'black', 'base');
      }
    }
  }
}
::v-deep {
  h1 {
    margin: 0 0 0.4em 0;
    @media #{map-get($display-breakpoints, 'xs-only')} {
      padding-top: 1rem;
    }
    @media #{map-get($display-breakpoints, 'lg-and-up')} {
      margin-bottom: 0.8rem;
      padding: 0;
    }
  }
  p {
    @media #{map-get($display-breakpoints, 'lg-and-up')} {
      margin-bottom: 0.8rem;
    }
  }
}
</style>
